
import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech1_f3a8903e07.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech3_eb031426db.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech4_8ef9319ee8.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_Bhim_Maya_at_Siliguri_City_Hospital_for_On_Job_Learning_7c1baadf2d.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_Sarala_Pandey_0efd209edd.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_Kabita_0f8468e819.webp";

const Img1 = "https://cdn.msu.edu.in/EMT_4_3d66f2cd55_3167e4e78f.png";
const Img2 = "https://cdn.msu.edu.in/Radiology_Lab_3e9cdc4dc2.webp";
const Img3 = "https://cdn.msu.edu.in/radiology_lab_9ea1be2870.webp";
const Img4 = "https://cdn.msu.edu.in/Physiotherapy_1_10ed952dc0.webp";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";


export const medicalRadiologyAndImagingTechnology = {
  heroSection: {
    breadcrumb: [
      { name: "Home", url: "/" },
      {
        name: "Industry Co-led UG Programmes",
        url: "/industry-co-led-ug-programmes",
      },
      {
        name: "Bachelor in Medical Radiology and Imaging Technology",
        url: "",
      },
    ],
    bannerImg: "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg",
    title: "Bachelor in Medical Radiology and Imaging Technology",
    poweredBy: {
      text: "Industry Skilling Partner",
      logo: EMVERSITY,
    },
    duration: "4 Year Undergraduate Degree Programme",
    description:
      "Learn about Human Anatomy and Physiology, General Biochemistry, Foundation in Digital Application, Radiographic Positioning Techniques and more ",
    stats: [
      {
        value: "Up to 70%",
        label: "Practical Curriculum",
      },
      {
        value: "Paid",
        label: "On-the-job learning",
      },
      {
        value: "100%",
        label: "Placement Assistance",
      },
    ],
    buttons: {
      download: "Download Brochure",
      enroll: "Enroll Now",
    },
    video: {
      thumbnail: "https://img.youtube.com/vi/_svldnORJj0/maxresdefault.jpg",
      buttonText: "Watch Programme Video",
      url: "https://www.youtube.com/embed/_svldnORJj0?si=1H5IXGtf2RUVMK0t",
    },
  },

  aboutSection: {
    tag: "ABOUT THE PROGRAMME",
    title: "Bachelor in Medical Radiology and Imaging Technology",
    description: [
      "The Bachelor in Medical Radiology and Imaging Technology is a four-year undergraduate programme that trains students to become skilled radiographers and imaging technologists. Students learn to operate X-ray machines, CT scanners, MRI systems, ultrasound equipment and other advanced medical imaging devices. The program covers radiation physics, image acquisition and processing, radiation safety, contrast media administration and patient positioning techniques.",
      "This program at Medhavi Skills University is delivered through a unique partnership model: MSU provides the academic framework, degree conferral, examinations and campus infrastructure, while Emversity delivers the industry-skilling component, including AR/VR simulation-based training, employer-co-designed curriculum modules, structured clinical internships and placement assistance through its network of 500+ healthcare employer partners.",
    ],
    stats: [
      { value: "Up to 70%", label: "Practical Curriculum" },
      { value: "Paid", label: "Paid on-the-job learning" },
      { value: "100%", label: "Placement Assistance" },
    ],
    approvals: [
      "UGC Approved",
      "NEP 2020 Aligned",
      "Govt. Scholarships Available",
    ],
    journeyTitle: "Your 4-Year Journey",
    journey: [
      {
        phase: "YEAR 1",
        title: "Biomedical & Imaging Foundations",
        description:
          "Build a strong base in human anatomy, physiology, biochemistry, imaging fundamentals and more",
      },
      {
        phase: "YEAR 2",
        title: "Core Radiology & Diagnostic Sciences",
        description:
          "Develop expertise in X-ray technology, radiographic positioning along with hands-on clinical exposure and patient care practices and more",
      },
      {
        phase: "YEAR 3",
        title: "Advanced Imaging & Specialisations",
        description:
          "Gain in-depth knowledge of CT, MRI, ultrasound and interventional radiology, specialised diagnostic procedures and more",
      },
      {
        phase: "YEAR 4",
        title: "Clinical Practice & Industry Readiness",
        description:
          "Apply your skills through hospital-based internships while building professional workplace competencies",
      },
      {
        phase: "GRADUATE",
        title: "Bachelor in Medical Radiology and Imaging Technology",
        description:
          "Skilled diagnostic imaging professional ready for modern healthcare environments",
      },
    ],
  },

  offeringSection: {
    tag: "OUR OFFERING",
    title: {
      first: "Comprehensive",
      highlight: "Healthcare Management Education",
    },
    description:
      "We offer a UGC-approved, 4 years undergraduate programme, Bachelor in Medical Radiology and Imaging Technology. It is an industry-aligned healthcare degree designed to build strong skills and prepare students for diverse roles.",
    learningBox: {
      title: "Key Areas of Learning",
      points: [
        "Basics of Radiation Physics",
        "Conventional Radiography & Equipments",
        "Pathology",
        "Cross-Sectional Anatomy",
        "Basic Techniques in CT Technology",
        "Ultrasound Techniques"
      ],
    },
    image: "https://cdn.msu.edu.in/large_Radiology_Lab_1_f50c4e92d3.webp",
  },

  whyEMT: {
    tag: "WHY MEDICAL RADIOLOGY & IMAGING. WHY NOW.",
    title: "See beyond symptoms. Power the decisions that save lives",
    description:
      "Our Bachelor in Medical Radiology and Imaging Technology is designed for the future of diagnostics, blending imaging science, cutting-edge technology and hands-on clinical training to prepare professionals for precision-driven healthcare environments.",
    stats: [
      {
        value: "0.65",
        text: "Radiologists are in India per lakh, showing severe specialist shortage.",
      },
      {
        value: "50 million",
        text: "Imaging procedures are performed yearly in India, increasing the need for advanced specialists.",
      },
    ],
  },

  msuAdvantages: {
    tag: "MSU ADVANTAGES",
    title: "Programme by Emversity, Delivered at MSU Campus",
    description:
      "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",
    cards: [
      {
        number: "01",
        text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
      },
      {
        number: "02",
        text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
      },
      {
        number: "03",
        text: "Well-equipped radiology labs, advanced training setups and hands-on field training",
      },
    ],
    pointerTitle: "Highlights from The Programme:",
    highlights: [
      "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
      "70% practical based curriculum",
      "Paid On-the-Job Learning (OJL)",
      "Industry-aligned curriculum & hands-on learning",
      "Learn from seasoned medical professionals",
      "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
      "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
      "Engage with industry experts to get invaluable insights and real-world perspectives",
    ],
    image: "https://cdn.msu.edu.in/small_DSC_00715_1_6d995bccf1.jpg",
  },

  CTA: {
    title: "Start Your Journey in Diagnostic Imaging with Emversity's",
    highlights: "Bachelor in Medical Radiology & Imaging Technology",
    url: "#",
    btnName: "Apply Now",
  },

  onJobtrainningData: {
    tag: "ON-THE-JOB LEARNING",
    title: "Practical Industry Exposure",
    description:
      "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
    images: [
      { id: 1, src: OJLImg1, alt: "Student operating imaging equipment" },
      { id: 2, src: OJLImg2, alt: "Student conducting radiography procedure" },
      { id: 3, src: OJLImg3, alt: "Student in radiology department" },
      { id: 4, src: OJLImg4, alt: "Student working with CT scanner" },
      { id: 5, src: OJLImg5, alt: "Student in MRI training session" },
      { id: 6, src: OJLImg6, alt: "Student in clinical internship" },
    ],
  },

  addtionSkill: {
    courseSections: {
      AdditionalSkills: {
        tag: "BONUS CREDENTIALS",
        title: "Additional Skills Certifications",
        description:
          "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like Basic Life Support (BLS), Advanced Cardiac Life Support (ACLS), Effective Patient Communication Skills, Radiation Safety & Protection, Interventional Radiology Skill Orientation and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",
        image: {
          url: "https://cdn.msu.edu.in/small_DSC_00715_1_6d995bccf1.jpg",
          alternativeText: "Skill Certification",
        },
        items: [
          {
            id: 1,
            text: "BLS & ACLS Certifications",
            icon: Icon2,
          },
          { id: 2, text: "Nationally & Globally Recognised", icon: Icon1 },
        ],
        button: { text: "Apply Now", link: "/apply" },
      },
    },
  },

  DoExperienceLearndata: {
    tag: "INFRASTRUCTURE",
    title: "Do-Experience-Learn",
    description:
      "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities",
    images: [
      { id: 1, src: Img1, size: "large", alt: "Classrooms" },
      { id: 2, src: Img2, size: "large", alt: "Radiology Labs" },
      { id: 3, src: Img3, size: "small", alt: "Imaging Equipment" },
      { id: 4, src: Img4, size: "small", alt: "CT & MRI Training Setup" },
      { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
    ],
  },

  studentStoriesData: {
    title: "Medhavians Speak",
    subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",
    students: [
      {
        name: "Radhika Chettri",
        image: Student2,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4",
      },
      {
        name: "Pratik Chettri",
        image: Student3,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4",
      },
      {
        name: "Suhana Sharma",
        image: Student4,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4",
      },
      {
        name: "Hissey Bhutia",
        image: Student1,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4",
      },
    ],
  },

  eligibility: {
    tag: "ELIGIBILITY",
    title: "Who Can Apply?",
    description:
      "12th Pass (10+2) with Physics, Chemistry and Biology/Mathematics (PCB/PCMB)",
    button: { text: "Apply Now", url: "" },
    items: [
      {
        title: "12th Pass - Science Stream",
        text: "Candidates who have passed 10+2 with Physics, Chemistry and Biology/Mathematics (PCB/PCMB) are eligible to apply for the Bachelor in Medical Radiology and Imaging Technology programme.",
      },
    ],
  },

  careerProspects: {
    tag: "CAREER PROSPECTS",
    heading: "Career Prospects",
    description:
      "Join this Bachelor in Medical Radiology and Imaging Technology and embark on a rewarding journey in the heart of the healthcare industry.",
    roles: [
      "Radiology Technician",
      "MRI/CT Scan Technologist",
      "Ultrasound/Sonography Technician",
      "X-Ray and Imaging Lab Technician",
      "Hospital Radiology Department Assistant",
      "Interventional Radiology Support Staff",
      "Medical Imaging Equipment Technician",
      "Clinical Imaging Coordinator",
      "Nuclear Medicine Technologist",
      "Radiology Quality Assurance Officer",
      "Research Assistant – Medical Imaging",
      "Health Informatics Specialist",
      "Imaging Services Trainer",
      "Entrepreneur",
      "Entrepreneur (Tech Startup/IT Venture)",
    ],
  },

  curriculumStructure: {
    label: "WHAT YOU WILL LEARN",
    heading: "Curriculum Structure",
    description:
      "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness and broad career opportunities across disciplines.",
    semesters: [
      {
        name: "Semester 1",
        title: "Building Foundations in Medical Imaging and Healthcare Sciences",
        description: "The first semester establishes a strong foundation in the scientific, technical, and professional principles that underpin medical radiology and imaging technology. Students develop an understanding of human anatomy, physiology, radiation physics, and healthcare systems while gaining familiarity with medical terminology, healthcare documentation, and ethical practices. The curriculum also emphasizes communication skills, digital literacy, management principles, and early clinical exposure, enabling learners to build the knowledge, professionalism, and technical awareness required for advanced training in diagnostic imaging and radiological sciences.",
        subjects: [
          { name: "Human Anatomy", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Physiology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Basics of Radiation Physics", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Introduction to Healthcare", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Medical Terminology & Record Keeping", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Basics of Computers and Information Science", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Medical Law and Ethics", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
          { name: "Professionalism and Values", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Principles of Management", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "English and Communication Skills", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "BMRIT Radiology Clinical Education – Part 1 (Studentship)", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" }
        ]
      },
      {
        name: "Semester 2",
        title: "Developing Core Competencies in Radiographic Imaging and Techniques",
        description: "The second semester introduces students to the fundamental principles and practices of diagnostic radiography. Learners gain an understanding of microbiology and biochemistry relevant to healthcare while developing technical knowledge of conventional radiographic equipment and imaging systems. The curriculum also focuses on radiographic positioning techniques, enabling students to understand image acquisition, patient positioning, and safety considerations essential for diagnostic accuracy. Through continued clinical exposure, students begin applying theoretical concepts in real-world radiology settings while strengthening their technical and professional competencies.",
        subjects: [
          { name: "Basics of Microbiology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Basics of Biochemistry", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Conventional Radiography & Equipments", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Clinical Radiography Positioning (Part 1)", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "BMRIT Radiology Clinical Education – Part II (Studentship)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" }
        ]
      },
      {
        name: "Semester 3",
        title: "Advancing Radiographic Techniques and Diagnostic Imaging Skills",
        description: "The third semester focuses on enhancing students' understanding of diagnostic imaging procedures and radiographic practices. Learners explore pathology to gain insights into disease processes while developing advanced competencies in radiographic positioning and image processing techniques. The curriculum also introduces contrast media and specialized radiological procedures, enabling students to understand the role of imaging in diagnosing a wide range of clinical conditions. Through continued clinical education, students strengthen their technical proficiency, patient handling skills, and readiness for professional radiology practice.",
        subjects: [
          { name: "Pathology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Clinical Radiography Positioning – Part II", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Radiography and Image Processing Techniques", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Contrast Media & Special Radiological Procedures", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "BMRIT Radiology Clinical Education – Part III (Studentship)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" }
        ]
      },
      {
        name: "Semester 4",
        title: "Mastering Advanced Imaging Technologies and Patient-Centred Care",
        description: "The fourth semester focuses on advanced diagnostic imaging concepts and specialized radiological procedures used in modern healthcare. Students develop an understanding of cross-sectional anatomy, advanced imaging equipment, and the physics that underpin contemporary radiology practices. The curriculum also introduces interventional radiology techniques and emphasizes patient care within radiology departments, enabling learners to balance technical proficiency with compassionate healthcare delivery. Through continued clinical education, students gain practical exposure to advanced imaging environments and strengthen their readiness for specialized radiology roles.",
        subjects: [
          { name: "Cross-Sectional Anatomy", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Modern Radiological Imaging Equipment and Physics", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Interventional Radiology Techniques", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Patient Care in Radiology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "BMRIT Radiology Clinical Education – Part IV (Studentship)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" }
        ]
      },
      {
        name: "Semester 5",
        title: "Enhancing Expertise in Advanced Imaging and Radiation Safety",
        description: "The fifth semester focuses on specialized imaging technologies, quality standards, and safety practices that are essential to modern radiology services. Students gain an understanding of computed tomography (CT) techniques, radiation protection principles, and quality assurance measures that support accurate and safe diagnostic imaging. The curriculum also familiarizes learners with regulatory requirements governing radiological practices, helping them develop a strong foundation in compliance, patient safety, and operational excellence. Through continued clinical education, students strengthen their technical competencies and readiness for advanced imaging environments.",
        subjects: [
          { name: "Basic Techniques in CT Technology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Radiation Safety in Diagnostic Radiology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Quality Assurance in Diagnostic Radiology and Regulatory Requirements", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "BMRIT Radiology Clinical Education – Part V (Studentship)", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" }
        ]
      },
      {
        name: "Semester 6",
        title: "Expanding Expertise Across Advanced Imaging Modalities",
        description: "The sixth semester introduces students to specialized imaging technologies that play a vital role in modern diagnostic and therapeutic healthcare. Learners develop an understanding of MRI, nuclear medicine, and ultrasound techniques, gaining insights into their principles, applications, and clinical significance. The curriculum also emphasizes research methodology and biostatistics, enabling students to develop analytical skills and an evidence-based approach to professional practice. Through continued clinical education, students strengthen their technical competencies and gain exposure to diverse imaging environments, preparing them for advanced roles in medical imaging and radiological sciences.",
        subjects: [
          { name: "Basic Techniques in MRI Technology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Introduction to Nuclear Medicine Techniques", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Ultrasound Techniques", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Biostatistics and Research Methodology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "BMRIT Radiology Clinical Education – Part VI (Studentship)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" }
        ]
      },
      {
        name: "Semester 7",
        title: "Transitioning to Professional Practice in Medical Imaging",
        description: "The internship phase provides students with comprehensive exposure to real-world radiology and diagnostic imaging environments, enabling them to apply the knowledge and technical skills acquired throughout the programme. Working alongside healthcare professionals across imaging departments, students gain hands-on experience in radiographic procedures, patient care, equipment handling, safety protocols, and clinical workflows. This immersive training strengthens professional competence, technical confidence, and clinical decision-making abilities, preparing graduates for successful careers in medical imaging and radiological sciences.",
        subjects: [
          { name: "Full Time Rotatory Internship", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
        ]
      },
      {
        name: "Semester 8",
        title: "Applying Diagnostic Imaging Skills in Clinical Practice",
        description: "The internship phase provides students with immersive clinical exposure across diverse radiology and imaging departments, enabling them to apply their academic knowledge and technical expertise in real-world healthcare settings. Through hands-on participation in diagnostic procedures, patient care activities, imaging workflows, and multidisciplinary collaboration, students gain practical experience while strengthening their professional competence and confidence. This intensive training helps bridge the gap between classroom learning and clinical practice, preparing graduates for successful careers in medical imaging and radiological sciences.",
        subjects: [
          { name: "Full Time Rotatory Internship", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
        ]
      },
      {
        name: "Value Addition",
        title: "Value-Added Learning Opportunities",
        description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
        "keySubjectsLabel": "Key Features",
        subjects: [
          { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
          { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
          { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
          { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
        ],
        "learningOutcomes": [
          "Gain real-world experience through the Red.Health Network internship",
          "Execute industry-based projects in healthcare settings",
          "Complete a capstone project and dissertation",
          "Transition confidently into healthcare management roles",
          "Prepare professionally through CV launch and career readiness activities"
        ]
      }
    ],
  },

  faq: {
    id: 106,
    title: "Bachelor in Medical Radiology and Imaging Technology",
    FAQ: [
      {
        id: 1,
        Question: "What is the university's role and what is Emversity's role?",
        Answer:
          "MSU manages all academic matters — admissions, examinations, marksheets, transcripts and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance and the Cambridge English program. Emversity does not collect fees, conduct exams or award degrees.",
      },
      {
        id: 2,
        Question: "Is placement or internship stipend guaranteed?",
        Answer:
          "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution.",
      },
      {
        id: 3,
        Question: "Is this program recognised and is it full-time?",
        Answer:
          "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university.",
      },
      {
        id: 4,
        Question: "How do I apply?",
        Answer:
          "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details and application deadlines, please contact the MSU admissions office directly.",
      },
      {
        id: 5,
        Question: "What is the Head Start Programme?",
        Answer:
          "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships.",
      },
      {
        id: 6,
        Question: "Is this programme NCAHP aligned?",
        Answer:
          "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus.",
      },
    ],
  },

  coursePrice: { price: "₹8,00,000" },
};